export const DietMealPlanTableColumns = [
    {
      id: "S.No",
      label: "S.No",
      minWidth: 70,
      align: "left",
    },
    {
      id: "patientName",
      label: "Patient Name",
      minWidth: 200,
      align: "left",
    },
    {
      id: "dietType",
      label: "Diet Type",
      minWidth: 150,
      align: "center",
    },
    {
      id: "phase",
      label: "Phase",
      minWidth: 120,
      align: "center",
    },
    {
      id: "currentWeek",
      label: "Current Week",
      minWidth: 120,
      align: "center",
    },
    {
      id: "createdAt",
      label: "Created At",
      minWidth: 150,
      align: "center",
    },
    {
      id: "updatedAt",
      label: "Updated At",
      minWidth: 150,
      align: "center",
    },
    {
        id: "details",
        label: "Details",
        minWidth: 70,
        align: "center",
    },
    {
        id: "active",
        label: "Active",
        minWidth: 70,
        align: "center",
    },
    {
        id: "generate",
        label: "Generate New",
        minWidth: 120,
        align: "center",
    },
    {
        id: "action",
        label: "Action",
        minWidth: 100,
        align: "center",
    },
];
  